import { render, staticRenderFns } from "./EChartsBox.vue?vue&type=template&id=31bef690&scoped=true"
import script from "./EChartsBox.vue?vue&type=script&lang=js"
export * from "./EChartsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bef690",
  null
  
)

export default component.exports